var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48838 4.2813C3.77323 4.06667 9.94264 3.02931 10.0453 3.01341C10.1055 3.00149 10.4063 2.99751 10.7178 3.00149C11.2204 3.01341 11.3655 3.03329 12.0274 3.18035C12.4345 3.27573 12.8203 3.3751 12.8805 3.40292C13.0468 3.48241 13.2309 3.68114 13.4432 4.01898C13.6733 4.38861 13.8255 4.54362 14.0308 4.63106C14.1158 4.66683 15.1741 4.88145 16.3811 5.11198C17.588 5.3425 19.0499 5.62469 19.6268 5.73201C20.2073 5.84329 20.7205 5.92278 20.7666 5.91086C20.8126 5.89894 20.8975 5.83137 20.9541 5.75983C21.2727 5.35442 21.3435 5.29083 21.4674 5.29083C21.6125 5.29083 22.6814 5.51341 22.7947 5.56905C22.8372 5.58892 22.9009 5.66444 22.9363 5.73598C22.9929 5.85124 23 5.98638 23 6.96014V8.05314L22.908 8.25187C22.8549 8.35918 22.7629 8.55791 22.7027 8.69305L22.5894 8.93152V11.4792C22.593 13.3274 22.6036 14.0587 22.6354 14.1581C22.6567 14.2336 22.7381 14.3965 22.8124 14.5277C22.8832 14.6549 22.9575 14.8258 22.9717 14.9053C22.9894 14.9848 23 15.5134 23 16.0817C23 16.9959 22.9894 17.131 22.9363 17.2463C22.9009 17.3178 22.8372 17.3933 22.7947 17.4132C22.7522 17.4331 22.1434 17.5762 21.4426 17.7272C20.7418 17.8822 18.2181 18.4347 15.8324 18.9593C13.4468 19.484 11.3762 19.9331 11.231 19.9609C10.6541 20.0603 10.201 20.0046 6.54115 19.3846C4.65457 19.0666 2.82817 18.7566 2.48838 18.701C1.79463 18.5857 1.59287 18.5022 1.35926 18.2439C1.18937 18.0531 1.08672 17.8226 1.03717 17.5364C0.987612 17.2423 0.987612 5.73996 1.03717 5.44584C1.08672 5.15967 1.18937 4.92915 1.35926 4.73837C1.59287 4.48002 1.79463 4.39656 2.48838 4.2813Z",
    fill: "#0A2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.043 10.4444C7.83446 10.5468 7.82385 10.6069 7.82385 11.5505C7.82385 12.2256 7.83446 12.4235 7.87687 12.5012C7.92636 12.6002 8.11723 12.7168 8.23034 12.7168C8.34345 12.7168 8.53432 12.6002 8.58381 12.5012C8.62622 12.4235 8.63683 12.2256 8.63683 11.5505C8.63683 10.5999 8.62622 10.5433 8.41061 10.4408C8.26215 10.3701 8.19146 10.3701 8.043 10.4444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05205 10.4334C3.8435 10.5288 3.82936 10.603 3.82936 11.5502C3.82936 12.5115 3.8435 12.5751 4.06618 12.6705C4.24645 12.7447 4.40198 12.7058 4.53276 12.5539L4.64233 12.4302V11.5502V10.6667L4.52923 10.543C4.39137 10.3945 4.22171 10.3557 4.05205 10.4334Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.48535,
    y: 9.89844,
    width: 1.5,
    height: 3.20508,
    rx: 0.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48047,
    y: 9.89844,
    width: 1.5,
    height: 3.20508,
    rx: 0.75,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9124,
    y: 6.51367,
    width: 0.980469,
    height: 10.4082,
    rx: 0.490234,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7474,
    y: 7.07227,
    width: 0.986328,
    height: 9.08203,
    rx: 0.493164,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3955,
    y: 7.41016,
    width: 0.875977,
    height: 8.25879,
    rx: 0.437988,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/cargo.d7bc0f96fc0cec4a507dd1d655ba6919.svg";
export { ForwardRef as ReactComponent };